import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'ngx-votes-renderer',
  templateUrl: './votes-renderer.component.html',
  styleUrls: ['./votes-renderer.component.scss']
})
export class VotesRendererComponent implements ICellRendererAngularComp {

  posVotes = 0;
  negVotes = 0;

  constructor() { }

  agInit(params: any): void {
    [this.posVotes, this.negVotes] = params.data.votes;
  }

  refresh(): boolean {
    return false;
  }

}
